import CustomerEntityContent from '@/components/entity-detail/components/Entity/CustomerEntity';
import type { TDetailServiceParams } from '@/components/entity-detail/types/EntityType.types';
import { CUSTOMER_PARAMS } from '@/constants/query-params/customer.constant';
import { customerService } from '@/services/rest';
import type { CustomerResponse } from '@/types/apps/customer.type';
import type { ApiResponse } from '@/types/common/api.type';
import { t } from '@/utils/lang';
import { Entity } from '../entity';

export class CustomerEntity extends Entity {
    public getTitleTemplate(response?: string): string {
        if (!response) {
            return t('Khách hàng');
        }

        return `${t('Khách hàng')}: ${this.getTitle(response)}`;
    }

    public getEntityComponent(): any {
        return CustomerEntityContent;
    }

    public getIncludeProperties() {
        return CUSTOMER_PARAMS;
    }

    public getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<CustomerResponse>> {
        return customerService().detail(params.id, {
            ...this.getIncludeProperties(),
            ...params,
        });
    }

    public getFieldName(): string {
        return 'name';
    }

    public getDetailUrl(id: string): string {
        return this.routeManager.getRouteMap()[this.getRouteDetail()].path(id);
    }

    public showDetailButton(): boolean {
        return true;
    }

    public getRouteDetail(): string {
        return this.routeManager.CUSTOMER_DETAIL;
    }
}
